import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';

export const useShouldShowTruemedBanner = () => {
  const { country } = useSiteStore(
    useShallow(({ country }) => ({
      country,
    })),
  );
  return country === 'US';
};
